
import defaultProductImage from "../../img/no_data.svg";
import { Pen, Trash } from "lucide-react";

const ProductItem = ( props ) => {
    var p = props.data;
    return (
        <div className="group rounded-xl border border-gray-200 bg-white p-4 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center gap-4">
                <img
                    className="h-14 w-14 rounded-lg object-cover border border-gray-200 cursor-pointer"
                    alt={p.productName}
                    src={( ( p.image ) ? p.image : defaultProductImage )}
                    onClick={props.onClick}
                />
                <div className="min-w-0 flex-1 cursor-pointer" onClick={props.onClick}>
                    <p className="text-base font-semibold text-gray-800 truncate"><a className="hover:underline" href={`/products/view/${p.id}`}>{p.productName}</a></p>
                    <p className="text-sm text-gray-500 mt-0.5 truncate">{p.packSize}</p>
                </div>
                <div className="flex items-center gap-2">
                    <button className="h-9 w-9 rounded-md border border-gray-200 flex items-center justify-center hover:bg-gray-50" onClick={props.onEdit}><Pen className="h-4 w-4 text-secondary-500 hover:text-primary-500" /></button>
                    <button className="h-9 w-9 rounded-md border border-gray-200 flex items-center justify-center hover:bg-gray-50" onClick={props.onDelete}><Trash className="h-4 w-4 text-secondary-500 hover:text-primary-500" /></button>
                </div>
            </div>
        </div>
    )
}
export default ProductItem;